import api from "./api";

// Capa de servicios API del dominio "tickets" (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- Listado / lectura ---
export const listTickets = (params) => api.get("/tickets", { params });
export const getTicket = (ticketId) => api.get(`/tickets/${ticketId}`);
export const getTicketByUuid = (uuid) => api.get(`/tickets/u/${uuid}`);
export const getTicketTabCounts = (params) =>
  api.get("/tickets/tab-counts", { params });
export const filterGlobalTickets = (params) =>
  api.get("/tickets/filter-global", { params });
export const searchGlobalTickets = (params) =>
  api.get("/tickets/search-global", { params });

// --- CRUD ---
export const createTicket = (payload) => api.post("/tickets", payload);
export const updateTicket = (ticketId, payload) =>
  api.put(`/tickets/${ticketId}`, payload);
export const deleteTicket = (ticketId) => api.delete(`/tickets/${ticketId}`);

// --- Acciones ---
export const markTicketRead = (ticketId) => api.put(`/tickets/${ticketId}/read`);
export const acceptTicket = (ticketId) => api.put(`/tickets/${ticketId}/accept`);
export const closeTicket = (ticketId) => api.put(`/tickets/${ticketId}/close`);
export const closeAllTickets = (payload) => api.post("/tickets/closeAll", payload);

// Vista Kanban de tickets.
export const getKanbanTickets = (params) => api.get("/ticket/kanban", { params });
